import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const TextArea = styled.textarea`
  width: 100%;
  height: 34px;
  max-height: 104px;
  padding: 9px 17px;
  color: #000;
  line-height: 20px;
  font-size: 13px;
  font-family: ${({ theme }) => theme.fontFamily};
  opacity: ${({ disabled }) => (disabled ? '.6' : 1)};
  overflow: hidden !important;
  resize: none;
  border: none;
  border-radius: 6px;
  background-color: #f2f2f2;
  outline: none;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &::placeholder {
    color: #6a6a6a;
  }

  ${({ theme }) => css`
    ${theme.input.styles}

    @media (${theme.mediaMobile}) {
      ${theme.input.mobile};
    }

    @media not (${theme.mediaMobile}) {
      ${theme.input.desktop};
    }
  `}
`;
